"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { Carousel } from "./Carousel";
import { DiwaliDesktopHero } from "./DiwaliDesktopHero";
import { DesktopHero } from "./DesktopHero";
import { DiwaliMobileHero } from "./DiwaliMobileHero";
import { MobileHero } from "./MobileHero";
const HeroV2: React.FC = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Carousel className="hidden lg:block relative w-full h-[740px]" dotContainerClassName="bottom-8" dotActiveClassName="w-8 bg-white/80 border border-white/40" dotInactiveClassName="w-2 bg-black/20 backdrop-blur-sm border border-white/40 hover:bg-white/50"><DiwaliDesktopHero /><DesktopHero /></Carousel>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <section className="bg-[#FCF8F8] relative overflow-hidden">{t0}<Carousel className="lg:hidden relative w-full h-[600px]" dotContainerClassName="bottom-4" dotActiveClassName="w-5 opacity-100 bg-white" dotInactiveClassName="w-1.5 opacity-50 bg-white"><DiwaliMobileHero /><MobileHero /></Carousel></section>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export default HeroV2;